<template>
  
       <div class="plus">
        <div class="top-box">
          <!-- <img class="return-img" src="@/assets/imgs/plusPage/return@3x.png" alt=""> -->
          <div class="top-center">
            <div class="head-box flex">
              <div class="head-box-img-box">
                <img class="head-box-img" :src="lawyerInfo.imgUlr || heading" alt="">
                <img class="is-vip" v-if="lawyerInfo.vipNo" src="@/assets/imgs/plusPage/is-vip.png" alt="">
              </div>
              <div class="head-right">
                <p class="name">{{lawyerInfo.realName}}{{lawyerInfo.realName?'，':''}}您好！</p>
                <p class="head-info">{{lawyerInfo.vipNo?'您已开通会员':'您还不是长律PLUS会员'}}</p>
              </div>
            </div>
            <div class="top-bottom flex">
              <div class="bottom-left flex">
                <img src="@/assets/imgs/plusPage/crown.png" alt="">
                <p>长律PLUS会员</p>
              </div>
              <div class="bottom-right">
                <!-- <p>暂未开通</p> -->
                <p>{{lawyerInfo.vipNo?`${lawyerInfo.vipInvalidTime}到期`:'暂未开通'}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 中间信息 -->
        <div class="content">
          <!-- 会员摘要 -->
          <div>
             <img class="content-top" src="@/assets/imgs/plusPage/add.png" alt="">
            <div class="item-box">
              <div class="box flex">
                <div v-for="item,index in privilegeList" :key="item.privilegeId">
                  <div class="item" :class="index == privilegeList.length -1?'last-child':''">
                    <img :src="item.icon" alt="">
                    <p class="item-tilte">{{item.name}}</p>
                    <p class="item-info">{{item.description}}</p>
                    <!-- <div class="num-box">
                      <p class="item-info-num" v-if="num">
                        <span>查看我的案源包</span>
                        <img src="@/assets/imgs/plusPage/gengduo.png" alt="">
                      </p>
                    </div> -->
                  </div>
                </div>
                
                <!-- <div class="item">
                  <img :class="!num?'':'img-padding-num'" src="@/assets/imgs/plusPage/info.png" alt="">
                  <p class="item-tilte">会员尊享案源包</p>
                  <div class="item-info">赠送本地案源*25赠送本地案源*25赠送本地案源*25</div>
                </div> -->
               
              </div>
            </div>
          </div>
          <!-- 卡片名称 -->
          <div>
            <img class="content-top" src="@/assets/imgs/plusPage/interests.png" alt="">
            <div class="price-box flex">
              <div class="box flex">
                <div class="price" v-for="item in cardList" :key="item.id" @click="changePrice(item)">
                  <div class="price-bgc" v-if="lawyerInfo.vipNo"><p class="bgc-opacity price-bgc-1"></p></div>
                  <div class="price-bgc" v-else :class="isChange == item.item.id?'price-border':''"><p  :class="isChange != item.item.id?'price-bgc-1':''" class="bgc-opacity"></p></div>
                  <p class="price-name">{{item.item.name}}</p>
                  <p class="price-present">¥ {{priceYuan(item.item.discountsPrice)}}</p>
                  <p class="price-original">原价¥{{priceYuan(item.item.originalPrice)}}</p>
                </div>

                <!-- <div class="price">
                  <div class="price-bgc"><p class="bgc-opacity price-bgc-1"></p></div>
                  <div class="price-bgc"><p class="bgc-opacity"></p></div>
                  <p class="price-name">111</p>
                  <p class="price-present">¥ 11}</p>
                  <p class="price-original">原价¥1</p>
                </div> -->
              </div>
            </div>
          </div>
          <!-- <div style="height:86px"></div> -->
        </div>
        <!-- 底部 -->
        
        <!-- 已经是vip未过期 -->
        <div class="footer footer-color" v-if="lawyerInfo.vipNo">
          <p class="isVip">已开通会员</p>
        </div>

        <div class="footer flex footer-bgc"  v-else>
          <div class="footer-left flex">
            <p class="price">{{priceYuan(curItem.discountsPrice)}}</p>
            <p class="name">元/{{curItem.name}}</p>
          </div>
          <p class="submit" @click="submit">立即开通</p>
        </div>
      </div>

 
</template>

<script>
import { getVip, getVipInfo} from '@/api/plus'
import {priceYuan} from '@/libs/tool.js'
export default {
  name: 'plus',
  data() { 
    return {
        priceYuan,
        num:1,
        cardList:[],
        isChange:1,
        curItem:{
          name:'周卡',
          presentPrice:399,
          originalPrice:1099
        },
        // 律师基本信息
        lawyerInfo:'',
        // vip信息
        VipInfo:'',
        privilegeList:[],
        vipId:'',
        // 默认头像
        heading:require('@/assets/imgs/plusPage/headimg.png')
    }
  },
  created(){
  },
  mounted(){
    // this.goBack()
    this.getVipInfos()
    this.getInfo()
    localStorage.setItem('source',this.$basicsTools.getQueryUrl('source'))
  },
  methods:{
    // 获取会员信息
    getVipInfos(){
       getVip().then(reg=>{
          if(!reg.code){
            this.VipInfo = [...reg.data]
            reg.data.forEach((item,index) => {
              this.cardList.push({id:item.vipId,item:item.classList[0]})
              if(index == 0) {
                this.privilegeList = item.privilegeList 
                this.vipId = item.vipId
                this.isChange = item.classList[0].id
              }
            });
            console.log(this.isChange);
            this.curItem = this.cardList[0].item
          }
        })

    },
    // 获取等级的类型
    getInfo(val){
      getVipInfo({vipId:val}).then(res=>{
          if(!res.code){
            res.data['isOverdue'] = new Date(res.data.vipInvalidTime || '') > new Date()
            this.lawyerInfo = {...res.data}
          }
      })
    },
    changePrice(item){
      this.isChange = item.item.id
      this.vipId = item.id
      this.curItem = {...item.item}
      this.VipInfo.forEach(k=>{
        if(k.vipId == item.id) this.privilegeList = k.privilegeList
      })
    },
    submit(){
      const obj = {
        vipId:this.vipId,
        vipClassId: this.isChange,
        type:'plus_number'
      }
      localStorage.setItem('SERVICESINFOS' , JSON.stringify(obj))
      this.$router.push({
        name:'plusFlow',
        query:{
          vipId:this.vipId,
          vipClassId: this.isChange,
          type:'plus_number'
        }
      })
    }
  }
 }
</script>

<style lang="scss" scoped>
  img{
    vertical-align: top;
  }
  .plus{
    font-family: '苹方-简';
    background-image: linear-gradient(#4B4847,#342319);
    min-height: 100%;
    .top-box{
      background: url("../../assets/imgs/plusPage/bgc.png") no-repeat;
      background-size: 100% 151px;
      background-color: #4B4847;
      height: 151px;
      position: relative;
      color: #fff;
      // .return-img{
      //   position: absolute;
      //   left: 16px;
      //   top: 11px;
      //   width: 22px;
      //   height: 22px;
      // }
      .top-center{
        padding-left: 12px;
        padding-top: 15px;
        padding-right: 16px;
        .head-box{
          justify-content: flex-start;
          .head-box-img-box{
            position: relative;
              margin-right: 16px;
            .head-box-img{
              border-radius: 50%;
              width: 44px;
              height: 44px;
            }
            .is-vip{
              position: absolute;
              width: 17px;
              height: 18px;
              right: 0;
              bottom: 0;
            }
          }
          
          .head-right{
            font-size: 12px;
            .name{
              font-size: 16px;
              line-height: 22px;
              margin-bottom: 6px;
              font-weight: bold;
            }
            .head-info{
              color:#CCC1BA ;
            }
          }
        }
        .top-bottom{
          padding: 40px 16px 0 16px;
          justify-content: space-between;
          align-items: center;
          color: #765215;
          height: 25px;
          font-size: 12px;
          .bottom-left{
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 700;
            img{
              width: 24px;
              height: 25px;
              margin-right: 6px;
            }
          }
        }
      }
    }
    .content{
      // height: calc(100% - 151px);
      // background-image: linear-gradient(#4B4847,#342319);
      text-align: center;
      padding-bottom: 86px;
      .content-top{
        width: 129px;
        height: 28px;
        padding: 34px 0 20px;
      }
      .item-box{
        padding: 0 16px;
        .box{
          overflow-x: scroll;
          align-items: center;
          white-space: nowrap;
          .last-child{
            margin-right: 0 !important;
          }
          .item{
            background: url("../../assets/imgs/plusPage/graphical.png") no-repeat;
            width: 120px;
            height: 126px;
            background-size: 100% 100%;
            text-align: center;
            color: #FFE4C8;
            font-size: 10px;
            margin-right: 8px;
            line-height: 1;
            
            img{
              width: 34px;
              height: 34px;
              padding-top: 12px;
              padding-bottom: 12px;
            }
            .img-padding-num{
              padding-bottom: 7px !important;
            }
            .item-tilte{
              width: 100px;
              padding: 0 10px;
              font-weight: bold;
              font-size: 14px;
              margin-bottom: 2px;
              line-height: 20px;
            }
            .item-info{
              font-size: 12px;
              transform: scale(0.83);
              // 展示两行  其余...
              line-clamp:2;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              white-space: normal;
              line-height: 12px;
              /*! autoprefixer:  ignore next */    // 这行必须加的，这个就是控制代码被编译不生效的问题的 上off  下on
              -webkit-box-orient: vertical;  // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
              /*! autoprefixer: on */
              display: -webkit-box;
              -webkit-line-clamp: 2;
              overflow: hidden;
              word-wrap: break-word;
              word-break: break-all;
              width: 100%;
              height: 23px;
            }
            .num-box{
                margin-top: 2px;
                margin-bottom: 6px;
              .item-info-num{
                align-items: center;
                justify-content: center;
                transform: scale(0.67);
                
                span{
                  margin-right: 3px;
                }
                img{
                  width: 9px;
                  height: 10px;
                  padding: 0;
                }
              }
            }
          }
        }
      }
      .price-box{
        padding: 0 16px 56px;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        .box{
          overflow-x: scroll;
          align-items: center;
          white-space: nowrap;
        }
        .price{
          box-sizing: border-box;
          text-align: center;
          color: #765215;
          font-size: 12px;
          background-image: linear-gradient(#FFF7F1,#F7D7B1);
          border-radius: 6px;
          width: 104px;
          height: 136px;
          font-weight: bold;
          margin-right: 15px;
          position: relative;
          &:last-child{
            margin-right: 0;
          }
          .price-bgc{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            width: 104px;
            height: 136px;
            border-radius: 6px;
            box-sizing: border-box;
            .bgc-opacity{
              width: 100%;
              height: 100%;
            }
            .price-bgc-1{
              opacity: .3;
              background-image: linear-gradient(#4B4847,#342319);
            }
          }
          .price-border{
            border: 3px solid #EFAE43;
          }
          .price-name{
            font-size: 14px;
            padding: 29px 0 7px;
            line-height: 22px;
            min-width: 104px;
          }
          .price-present{
            font-size: 20px;
            margin-bottom: 7px;
            line-height: 28px;
          }
          .price-original{
            font-weight: normal;
            text-decoration: line-through;
            color: #797979;
          }
        }
      }
    }
    .footer-bgc{
      background: url("../../assets/imgs/plusPage/footer.png") no-repeat;
      background-size: 100% 100%;
    }
    .footer-color{
      background-color: #FFF5ED;
    }
    .footer{
      position: fixed;
      bottom: 30px;
      width: 343px;
      align-items: center;
      height: 56px;
      border-radius: 28px;
      left: 16px;
      justify-content: space-between;
      font-weight: bold;
     
      .footer-left{
        display: flex;
        align-items: center;
        font-size: 12px;
        padding-left: 18px;
        color: #D1A655;
        .price{
          font-size: 20px;
          margin-left: 10px;
          color: #F4CD84;
        }
        .name{
          margin-left: 8px;
          max-width: 90px;
          overflow: hidden;/*超出部分隐藏*/
          white-space: nowrap;/*不换行*/
          text-overflow:ellipsis;/*超出部分文字以...显示*/
        }
      }
      .submit{
        background: url("../../assets/imgs/plusPage/footer-right.png") no-repeat;
        background-size: 100% 100%;
        width: 119px;
        font-size: 18px;
        line-height: 42px;
        height: 46px;
        color: #3B2D26;
        text-align: center;
        margin-top: 7px;
        margin-right: 12px;
      }
      .isVip{
        text-align: center;
        line-height: 56px;
        color: #3C3C3C;
        font-size: 18px;
      }
    }
  }
</style>